import Vue from "vue";

export async function analyse(images) {
  const form = new FormData();
  images.forEach((image) => {
    form.append("image[]", image);
  });

  const response = await Vue.prototype.$http.post(
    "/customer-inbound/analyse-image",
    form
  );

  return response.data;
}

export async function analyseInvoice(invoice) {
  const form = new FormData();
  form.append("invoice", invoice);

  const response = await Vue.prototype.$http.post(
    "/customer-inbound/analyse-invoice",
    form
  );

  return response.data;
}

export async function generateProcess(payload) {
  const response = await Vue.prototype.$http.post(
    "/customer-inbound/process",
    payload
  );

  return response.data;
}

export async function decideFlow(participation) {
  const response = await Vue.prototype.$http.post(
    "/customer-inbound/decide-flow",
    {
      participation,
    }
  );

  return response.data;
}

export async function returnPathImages(images) {
  const form = new FormData();
  images.forEach((image) => {
    form.append("image[]", image);
  });

  const response = await Vue.prototype.$http.post(
    "/customer-inbound/return-path-images",
    form
  );

  return response.data;
}

export async function autocompleteZipCode(country_code, postal_code) {
  const response = await Vue.prototype.$http.get(
    `/customer-inbound/countries/${country_code}/${postal_code}`
  );

  return response.data;
}

export async function getCountryAreas(country_code) {
  const response = await Vue.prototype.$http.get(
    `/customer-inbound/countries/${country_code}/areas`
  );

  return response.data;
}

export async function getCities(country_area_id) {
  const response = await Vue.prototype.$http.get(
    `/customer-inbound/country_areas/${country_area_id}/cities`
  );

  return response.data;
}

export async function getCityAreas(city_id) {
  const response = await Vue.prototype.$http.get(
    `/customer-inbound/cities/${city_id}/areas`
  );

  return response.data;
}
